import React from 'react';
import PropTypes from 'prop-types';

import ListItem from '../ListItem';

import './GlobalActions.scss';

export default function GlobalActions({ clearAll, selectAll }) {
  return (
    <div className="GlobalActions">
      <ListItem
        onClick={e => {
          e.stopPropagation();
          selectAll();
        }}
      >
        <span>Select all</span>
      </ListItem>
      <ListItem
        onClick={e => {
          e.stopPropagation();
          clearAll();
        }}
      >
        <span>Clear all</span>
      </ListItem>
    </div>
  );
}

GlobalActions.propTypes = {
  clearAll: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
};
